import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import SEOHead from '../components/SEOHead'

const TermsOfService = () => {
  const { t } = useTranslation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className="section-padding bg-[#0a0a0f] min-h-screen pt-32 pb-16">
      <SEOHead
        title={t('terms.title', 'Terms of Service — nodatx')}
        description={t('terms.description', 'Terms of Service for nodatx. Learn about your obligations and rights when using our business automation and n8n system integration services.')}
        canonical="https://nodatx.com/terms"
      />
      <div className="container-custom max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 border-b border-white/10 pb-6">{t('terms.heading', 'Terms of Service')}</h1>
        
        <div className="space-y-8 text-gray-300 leading-relaxed text-lg">
          <section>
            <p className="mb-4">
              {t('terms.intro', 'Welcome to nodatx. By using our website and contacting us for consulting or automation services, you agree to these Terms of Service. Please read them carefully.')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('terms.section1', '1. Nature and Delivery of Services')}</h2>
            <p className="mb-4">
              {t('terms.section1Desc', 'We provide business automation solutions, system integrations, and workflow consulting using technologies like n8n. Each service delivery is based on a Statement of Work (SOW) or written quote approved by both parties. We commit to delivering projects by agreed deadlines, but timelines may be affected by client responsiveness or third-party system access availability (API access).')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('terms.section2', '2. Client Obligations')}</h2>
            <p className="mb-4">{t('terms.section2Desc', 'To achieve the best results for your project, the client commits to:')}</p>
            <ul className="list-disc list-inside space-y-2 mr-4">
              <li>{t('terms.section2Item1', 'Providing all necessary information and sufficient access to accounts (required permissions for scripts) to successfully implement automation.')}</li>
              <li>{t('terms.section2Item2', 'Responding quickly to team inquiries so that timelines and objectives are met on schedule.')}</li>
              <li>{t('terms.section2Item3', 'Paying fees according to the schedule agreed upon in the independent project contract.')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('terms.section3', '3. Payment and Fees')}</h2>
            <p className="mb-4">
              {t('terms.section3Desc', 'Our n8n-based projects typically start from $200 and can exceed $5000 based on complexity requirements. All payment terms (deposits, upon delivery) will be clearly outlined in the quote. We do not begin execution until the agreed deposit is received.')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('terms.section4', '4. Limitation of Liability')}</h2>
            <p className="mb-4">
              {t('terms.section4Desc', 'We build the best workflows with maximum efficiency, but nodatx will not be liable for any indirect losses or downtime beyond our control resulting from changes in APIs of applications like Google, Facebook, or any other tools we integrate with, or service interruptions from third-party platform servers.')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('terms.section5', '5. Intellectual Property')}</h2>
            <p className="mb-4">
              {t('terms.section5Desc', 'Any workflows we build for you or customized templates sold will be your property for internal use once you have fully paid for the project. Reselling custom code or workflows specifically configured for you as an independent product to a third party without our written permission is strictly prohibited.')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('terms.section6', '6. Contract Termination')}</h2>
            <p className="mb-4">
              {t('terms.section6Desc', 'Either party has the right to terminate the contract in case of material breach of terms, provided written notice is given to the other party. In the event of service termination before completion, the client will be responsible for payment for work completed up to the termination date.')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('terms.section7', '7. Contact Us')}</h2>
            <p className="mb-4">
              {t('terms.section7Desc', 'If you have questions about the Terms of Service, please contact us at:')}
            </p>
            <p className="text-white font-semibold flex items-center gap-2">
              <span>{t('terms.email', 'Email:')}</span>
              <a href="mailto:support@nodatx.com" className="text-purple-400 hover:underline transition-all">support@nodatx.com</a>
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-center text-gray-500 text-sm">
          {t('terms.lastUpdated', 'Last updated: February 21, 2026')}
        </div>
      </div>
    </main>
  )
}

export default TermsOfService